import { type MetaFunction } from '@remix-run/node'

import { Footer, Header } from '#app/components'
import { Icon, Wrapper } from '#app/components/ui'
import { useOptionalUser } from '#app/utils/user.ts'

const cards = [
	{
		name: 'Sales Support',
		description:
			'Need help choosing the right plan or have a question about pricing? Our sales team is here to assist you with any inquiries or special requests.',
		icon: 'mobile',
	},
	{
		name: 'Technical Support',
		description:
			'Encountering technical issues or need help with features? Our tech support team is ready to solve any problems and guide you through solutions step-by-step.',
		icon: 'paper-plane',
	},
	{
		name: 'Media Inquiries',
		description:
			'For all press and media inquiries, please contact our public relations team. We’re ready to provide you with the latest news and insights about our company.',
		icon: 'file-text',
	},
]

export default function SupportRoute() {
	const user = useOptionalUser()
	const isLoggedIn = user?.id ? true : false
	return (
		<main>
			<Header isLoggedIn={isLoggedIn} />
			<div className="flex w-full flex-col items-center">
				<Wrapper>
					<div className="relative isolate overflow-hidden bg-white py-24 dark:bg-background sm:py-32">
						<div className="mx-auto max-w-7xl px-6 lg:px-8">
							<div className="mx-auto max-w-2xl lg:mx-0">
								<h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
									Support center
								</h2>
								<p className="mt-6 py-4 text-lg leading-8 text-gray-600 dark:text-gray-300">
									Welcome to the Top Timelines Support Center. Whatever your
									question, our dedicated team is here to assist you in finding
									the answers you need as quickly and efficiently as possible.
									Reach out to hello@toptimelines.com for assistance.
								</p>
							</div>
							<div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-8">
								{cards.map(card => (
									<div
										key={card.name}
										className="flex gap-x-4 rounded-xl bg-white/5 p-6 ring-1 ring-inset ring-white/10"
									>
										<div className="flex-none text-emerald-500">
											<Icon
												className="h-7 w-5"
												// TODO: Address Type Error
												// @ts-ignore
												name={card.icon}
											></Icon>
										</div>
										<div className="text-base leading-7">
											<h3 className="font-semibold dark:text-white">
												{card.name}
											</h3>
											<p className="mt-2 text-gray-600 dark:text-gray-300">
												{card.description}
											</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</Wrapper>
			</div>
			<Footer />
		</main>
	)
}

export const meta: MetaFunction = () => [{ title: 'Top Timelines | Support' }]
